import { DSTextInput } from '@vr/ds-react'
import { Controller } from 'react-hook-form'

import { ICompanyIdProps } from './interface'

const formatCNPJ = (value: string) => {
  if (!value) return value
  const digits = value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 14)
  if (digits.length <= 2) return digits
  if (digits.length <= 5) return `${digits.slice(0, 2)}.${digits.slice(2)}`
  if (digits.length <= 8)
    return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5)}`
  if (digits.length <= 12)
    return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(
      5,
      8
    )}/${digits.slice(8)}`
  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(
    5,
    8
  )}/${digits.slice(8, 12)}-${digits.slice(12)}`
}

const CompanyId = ({ control, accountKey }: ICompanyIdProps) => {
  return (
    <Controller
      key={accountKey}
      name='companyId'
      control={control}
      render={({ field: { onChange, value } }) => (
        <DSTextInput
          value={value}
          onChange={e => onChange(formatCNPJ(e.target.value))}
          placeholder='Buscar por CNPJ'
          label='CNPJ'
        />
      )}
    />
  )
}

export default CompanyId
